// src/components/SearchNavigation.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SearchNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { id: 'keyword', icon: 'bx-search-alt-2', label: 'Keyword', path: '/keyword' },
    { id: 'citation', icon: 'bx-book-bookmark', label: 'Citation', path: '/citation' },
    { id: 'advance', icon: 'bx-filter-alt', label: 'Advance', path: '/search' },
    { id: 'nominal', icon: 'bx-user', label: 'Nominal', path: '/nominal' },
    { id: 'database', icon: 'bx-data', label: 'Database', path: '/database' },
    // { id: 'virtual', icon: 'bx-bot', label: 'Virtual Assistant', path: '/virtual' }
  ];

  return (
    <>
      <div className="search-navigation">
        <div className="search-nav-container">
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`search-nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              <i className={`bx ${item.icon}`}></i>
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      </div>

      <style>{`
        /* Search Navigation Bar */
        .search-navigation {
          position: fixed;
          top: 74px;
          left: 0;
          right: 0;
          background: white;
          border-bottom: 2px solid #f0f0f0;
          z-index: 999;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        }

        .search-nav-container {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 20px;
          max-width: 1400px;
          margin: 0 auto;
          overflow-x: auto;
        }

        .search-nav-item {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 20px;
          background: #fafafa;
          border: 2px solid transparent;
          border-radius: 12px;
          color: #555;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          white-space: nowrap;
          flex-shrink: 0;
        }

        .search-nav-item i {
          font-size: 18px;
          transition: transform 0.3s ease;
        }

        .search-nav-item:hover {
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.1), rgba(233, 30, 99, 0.05));
          border-color: rgba(245, 166, 35, 0.3);
          color: #E91E63;
          transform: translateY(-2px);
        }

        .search-nav-item:hover i {
          transform: scale(1.1);
        }

        .search-nav-item.active {
          background: linear-gradient(135deg, #E91E63, #c41849);
          color: white;
          border-color: transparent;
          box-shadow: 0 4px 15px rgba(245, 166, 35, 0.3);
        }

        .search-nav-item.active i {
          animation: bounce 0.6s ease;
        }

        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-4px); }
        }

        /* Scrollbar for mobile */
        .search-nav-container::-webkit-scrollbar {
          height: 4px;
        }

        .search-nav-container::-webkit-scrollbar-track {
          background: #f1f1f1;
        }

        .search-nav-container::-webkit-scrollbar-thumb {
          background: linear-gradient(135deg, #E91E63, #c41849);
          border-radius: 4px;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .search-navigation {
            top: 70px;
          }

          .search-nav-container {
            justify-content: flex-start;
            padding: 10px 15px;
            gap: 6px;
          }

          .search-nav-item {
            padding: 8px 16px;
            font-size: 13px;
          }

          .search-nav-item i {
            font-size: 16px;
          }

          .search-nav-item span {
            display: none;
          }

          .search-nav-item {
            width: 40px;
            height: 40px;
            padding: 0;
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .search-nav-item {
            width: 36px;
            height: 36px;
          }

          .search-nav-item i {
            font-size: 18px;
          }
        }
      `}</style>
    </>
  );
};

export default SearchNavigation;